import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import './styles.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';

import PeriodContext from '../../Contexts/PeriodContext';
import apiTuig from '../../services/apiTuig';

import { UltimaAtualizacao, Insumo } from '../../Types/Types';
import LoginContext from '../../Contexts/LoginContext';

import { useHistory } from 'react-router-dom';

const Insumos = () => {

        const Period = useContext(PeriodContext);
        const Login = useContext(LoginContext);
        
        //Funcionamento do filtro de busca e enter no input
        const [txtInsumo, settxtInsumo] = useState('');
        const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            settxtInsumo(event.target.value);
        };
        const handlePressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
                if (event.key === 'Enter') {
                    HandleClickButtonBuscarInsumo();
                }
        };
        
        const history = useHistory();

        const [insumos, setInsumos] = useState<Insumo[]>([{
                    idMateria: '',
                    descricao: '',
                    qtdEstoque: '',
                    custo: 0
                }]);

        const [carregandoInsumos,setCarregandoInsumos] = useState(true);
        const [ultimaAtualizacao, setUltimaAtualizacao] = useState<UltimaAtualizacao>({
            ultAtualizacao: '',
            regPendentes: '',
            error: ''
        });

        useEffect(() => {
            LoadHome();       
        },[]); 

        async function CarregarUltAtualizacao() {
            try {
                if (Login.user != null) {
                    await apiTuig.get(`ultimaAtualizacao?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}`).then(response => {
                        setUltimaAtualizacao(response.data);
                        //Se senha ou autorizacao mudar no servidor, desloga usuario
                        if (response.data.error !== '') {
                            alert(response.data.error);
                            return (
                                <div>
                                    {GoToLogin()};
                                </div>
                            )
                        }
                        })
                    }
            } catch (err) {
                alert(`Erro ao carregar hora da última atualização, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        async function CarregarInsumos() {
            try {
                if (Login.user != null) {
                    setCarregandoInsumos(true);
                    await apiTuig.get<Insumo[]>(`insumos?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}`).then(response => {
                        const insumo = response.data;
                        setInsumos(insumo);
                        setCarregandoInsumos(false);   
                    })
                }
            } catch (err) {
                setCarregandoInsumos(false);
                alert(`Erro ao carregar insumos, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        function HandleClickButtonBuscarInsumo() {
                    try {
                        if (Login.user != null) {
                            setCarregandoInsumos(true);
                             apiTuig.get<Insumo[]>(`insumos?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}&busca=${txtInsumo}`).then(response => {
                                const insumo = response.data;
                                setInsumos(insumo);
                                setCarregandoInsumos(false);   
                            })
                        }
                    } catch (err) {
                        setCarregandoInsumos(false);
                        alert(`Erro ao carregar insumos, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
                    }
                return;
            }

        useEffect(() => {
            CarregarUltAtualizacao();
            {/* Comenttado e setado para falso para não carregar todos os insumos na primeira abertura nem mostrar o loading infinito */}
            //CarregarInsumos();
            setCarregandoInsumos(false);
        },[]);

        function GoToLogin() {
            history.push('/');
        }
    
        function LoadHome() {
            // if (sessionStorage.getItem('@tuigcloud/dayFrom') != null) {
            //     const momentObj = moment(sessionStorage.getItem('@tuigcloud/dayFrom'), 'DD/MM/YYYY');
            //     Period.dayFrom = momentObj.toDate();
            // }
            Login.isAutenticated = sessionStorage.getItem('@tuigcloud/isAutenticated');
            Login.user = sessionStorage.getItem('@tuigcloud/user');
            Login.pass = sessionStorage.getItem('@tuigcloud/pass');
            Login.client = localStorage.getItem('@tuigcloud/client');
            Login.clientName = sessionStorage.getItem('@tuigcloud/clientName');
            
            if (Login.isAutenticated === 'true') {
                return (
                        <div id="home">
                    <div className="content">
                        <Header />
                        <br/>
                        <br/>
                        <p>Atualizado em {ultimaAtualizacao.ultAtualizacao}</p>
                        <p>{ultimaAtualizacao.regPendentes} registros a sincronizar</p>
                        <br/>
                        <h3>{Login.clientName}</h3>
                        <h1>Insumos</h1>
                        <br/>
                        <input id="inputBuscaInsumo" type="text" value={txtInsumo} onChange={handleInputChange} placeholder='Nome do insumo' onKeyPress={handlePressEnter}/>
                        <button id="botaoBuscarInsumo" type="button" onClick={HandleClickButtonBuscarInsumo}>buscar</button>
                        <br/>
                        <br/>
                        {carregandoInsumos ? <Loading /> : <div id="container"> {/* If ternario no início para caso o array seja vazio não mostrar nem o spinner de loading nem ps textos complementares tipo o P adicional do código do insumo */}
                                                               {insumos.map(insumo => (insumo.idMateria ?  
                                                               <p key={insumo.idMateria}> P{insumo.idMateria} - {insumo.descricao}
                                                               <br/>
                                                               Estoque: {insumo.qtdEstoque}
                                                               <br/>
                                                               Valor Custo: {insumo.custo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} 
                                                               <hr/>
                                                               </p>
                                                               
                                                               : '' ))}  
                                                               <br/>
                                                               </div>}
                        <Footer />
                        
                    </div>
                </div>
                )
            }
            else {
                return (
                    <div>
                        {GoToLogin()};
                    </div>
                )
            }
        }
    return (
        <div>{LoadHome()}</div>
    );
};

export default Insumos;
